import { UserStore } from './user/user-store.state';
import { VenueStore } from './venue/venue-store.state';
import { EntityStore } from './entity/entity-store.state';

export const store = [
  UserStore,
  VenueStore,
  EntityStore
];
